'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

// Those properties are wrapped in the object, and made getters to allow changing their values after this object
// was imported. If those were just constants, it would not be possible to overwrite their value using environment variables,
// after this file was imported anywhere. This makes it a little bit lett performant, but much easier to use.

var endpoints = {
  /**
   * Sets the root domain, serves as an override to process.env.ENDPOINTS_ROOT_DOMAIN
   */
  set endpointsRootDomain(endpointsRootDomain) {
    this._endpointsRootDomain = endpointsRootDomain;
  },
  get endpointsRootDomain() {
    return this._endpointsRootDomain;
  },
  /**
   * Gets the TLD and main domain part of the url.
   * @return {Array} Element 0 in the array should be  TLD and element 1 should be main domain.
   */
  get tldAndEnvironment() {
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
      return process.env.MOBILE_ENV === 'development' ? ['com', 'demo-owl'] : ['io', 'import'];
    } else {
      return global.location ? global.location.hostname.split('.').reverse().slice(0, 2) : ['io', 'import'];
    }
  },
  /**
   * Just a pure root domain, dependent on the environment, do it might be `import.io`,
   * 'staging-owl.com', 'dev-owl.com' or a value of ENDPOINTS_ROOT_DOMAIN
   * environment variable.
   * @type {String}
   */
  get rootDomain() {
    var _tldAndEnvironment = _slicedToArray(this.tldAndEnvironment, 2),
      tld = _tldAndEnvironment[0],
      environment = _tldAndEnvironment[1];
    return this.endpointsRootDomain || process.env.ENDPOINTS_ROOT_DOMAIN || environment + '.' + tld;
  },
  /**
   * Main domain, dependent on the environment, so it might be `https://import.io`,
   * 'https://staging-owl.com', 'https://dev-owl.com' or a value of
   * ENDPOINTS_BASE_URL environment variable.
   * @type {String}
   */
  get baseUrl() {
    return process.env.ENDPOINTS_BASE_URL || 'https://' + this.rootDomain;
  },
  /**
   * Adds `api.` to the beginning of the baseUrl. So possible values are
   * `https://api.import.io`, 'https://api.staging-owl.com', 'https://api.dev-owl.com' or a value of
   * ENDPOINTS_API_BASE_URL environment variable.
   * @type {String}
   */
  get apiBaseUrl() {
    return process.env.ENDPOINTS_API_BASE_URL || 'https://api.' + this.rootDomain;
  },
  /**
   * Provides a valid magic domain name by adding `magic.` to the beginning of the baseUrl. So possible values are
   * `https://magic.import.io`, 'https://magic.staging-owl.com', 'https://magic.dev-owl.com' or a value of
   * ENDPOINTS_MAGIC_BASE_URL environment variable.
   * @type {String}
   */
  get magicBaseUrl() {
    return process.env.ENDPOINTS_MAGIC_BASE_URL || 'https://magic.' + this.rootDomain;
  },
  /**
   * Provides a valid elf domain name by adding `elf.` to the beginning of the baseUrl. So possible values are
   * `https://elf.import.io`, 'https://elf.staging-owl.com', 'https://elf.dev-owl.com' or a value of
   * ENDPOINTS_ELF_BASE_URL environment variable.
   * @type {String}
   */
  get elfBaseUrl() {
    return process.env.ENDPOINTS_ELF_BASE_URL || 'https://elf.' + this.rootDomain;
  },
  /**
   * Provides the service API domain name by adding `service.` to the beginning of the baseUrl. So possible values are
   * `https://service.import.io`, 'https://service.staging-owl.com', 'https://service.dev-owl.com'
   * or a value of ENDPOINTS_SERVICE_BASE_URL environment variable.
   * @type {String}
   */
  get serviceBaseUrl() {
    return process.env.ENDPOINTS_SERVICE_BASE_URL || 'https://service.' + this.rootDomain;
  },
  /**
   * Provides a valid feeds domain name by adding `feeds.` to the beginning of the baseUrl. So possible values are
   * `https://feeds.import.io`, 'https://feeds.staging-owl.com', 'https://feeds.dev-owl.com'
   * or a value of ENDPOINTS_FEEDS_BASE_URL environment variable.
   * @type {String}
   */
  get feedsBaseUrl() {
    return process.env.ENDPOINTS_FEEDS_BASE_URL || 'https://feeds.' + this.rootDomain;
  },
  /**
   * Provides a valid store domain name by adding `store.` to the beginning of the baseUrl. So possible values are
   * `https://store.import.io`, 'https://store.staging-owl.com', 'https://store.dev-owl.com'
   * or a value of ENDPOINTS_STORE_BASE_URL environment variable.
   * @type {String}
  */
  get storeBaseUrl() {
    return process.env.ENDPOINTS_STORE_BASE_URL || 'https://store.' + this.rootDomain;
  },
  /**
   * Provides a valid get-data domain name by adding `get-data.` to the beginning of the baseUrl. So possible values are
   * `https://get-data.import.io`, 'https://get-data.staging-owl.com', 'https://get-data.dev-owl.com'
   * or a value of ENDPOINTS_GET_DATA_BASE_URL environment variable.
   * @type {String}
   */
  get getDataBaseUrl() {
    return process.env.ENDPOINTS_GET_DATA_BASE_URL || 'https://get-data.' + this.rootDomain;
  },
  /**
   * Provides a valid extraction domain name by adding `extraction.` to the beginning of the baseUrl. So possible values are
   * `https://extraction.import.io`, 'https://extraction.staging-owl.com', 'https://extraction.dev-owl.com'
   * or a value of ENDPOINTS_EXTRACTION_BASE_URL environment variable.
   * @type {String}
   */
  get extractionBaseUrl() {
    return process.env.ENDPOINTS_EXTRACTION_BASE_URL || 'https://extraction.' + this.rootDomain;
  },
  /**
   * Provides a valid schedule domain name by adding `schedule.` to the beginning of the baseUrl. So possible values are
   * `https://schedule.import.io`, 'https://schedule.staging-owl.com', 'https://schedule.dev-owl.com'
   * or a value of ENDPOINTS_SCHEDULE_BASE_URL environment variable.
   * @type {String}
   */
  get scheduleBaseUrl() {
    return process.env.ENDPOINTS_SCHEDULE_BASE_URL || 'https://schedule.' + this.rootDomain;
  },
  /**
   * Provides a valid subscription domain name by adding `subscription.` to the beginning of the baseUrl. So possible values are
   * `https://subscription.import.io`, 'https://subscription.staging-owl.com', 'https://subscription.dev-owl.com'
   * or a value of ENDPOINTS_SUBSCRIPTION_BASE_URL environment variable.
   * @type {String}
   */
  get subscriptionBaseUrl() {
    return process.env.ENDPOINTS_SUBSCRIPTION_BASE_URL || 'https://subscription.' + this.rootDomain;
  },
  /**
   * Provides a valid webcache domain name by adding `webcache.` to the beginning of the baseUrl. So possible values are
   * `https://webcache.import.io`, 'https://webcache.staging-owl.com', 'https://webcache.dev-owl.com'
   * or a value of ENDPOINTS_WEBCACHE_BASE_URL environment variable.
   * @type {String}
   */
  get webcacheBaseUrl() {
    return process.env.ENDPOINTS_WEBCACHE_BASE_URL || 'https://webcache.' + this.rootDomain;
  },
  /**
   * Provides a valid run domain name by adding `run.` to the beginning of the baseUrl. So possible values are
   * `https://run.import.io`, 'https://run.staging-owl.com', 'https://run.dev-owl.com'
   * or a value of ENDPOINTS_RUN_BASE_URL environment variable.
   * @type {String}
   */
  get runBaseUrl() {
    return process.env.ENDPOINTS_RUN_BASE_URL || 'https://run.' + this.rootDomain;
  },
  /**
   * Provides a valid billing domain name by adding `billing.` to the beginning of the baseUrl. So possible values are
   * `https://billing.import.io`, 'https://billing.staging-owl.com', 'https://billing.dev-owl.com'
   * or a value of ENDPOINTS_BILLING_BASE_URL environment variable.
   * @type {String}
   */
  get billingBaseUrl() {
    return process.env.ENDPOINTS_BILLING_BASE_URL || 'https://billing.' + this.rootDomain;
  },
  /**
   * == DEPRECATED ==
   * Provides a valid schedule domain name by adding `eec.` to the beginning of the baseUrl. So possible values are
   * `https://eec.import.io`, 'https://eec.staging-owl.com', 'https://eec.dev-owl.com'
   * or a value of ENDPOINTS_EEC_BASE_URL environment variable.
   * @type {String}
   */
  get eecBaseUrl() {
    return process.env.ENDPOINTS_EEC_BASE_URL || 'https://eec.' + this.rootDomain;
  },
  /**
   * Provides a valid list-producer domain name by adding `list-producer.` to the beginning of the baseUrl. So possible values are
   * `http://list-producer.import.io`, 'http://list-producer.staging-owl.com', 'http://list-producer.dev-owl.com'
   * or a value of ENDPOINTS_LIST_PRODUCER_BASE_URL environment variable.
   * @type {String}
   */
  get listProducerBaseUrl() {
    return process.env.ENDPOINTS_LIST_PRODUCER_BASE_URL || 'https://list-producer.' + this.rootDomain;
  },
  /**
   * Provides a valid dash domain name by adding `dash.` to the beginning of the baseUrl. So possible values are
   * `https://dash.import.io`, 'https://dash.staging-owl.com', 'https://dash.dev-owl.com'
   * or a value of ENDPOINTS_DASH_BASE_URL environment variable.
   * @type {String}
   */
  get dashBaseUrl() {
    return process.env.ENDPOINTS_DASH_BASE_URL || 'https://dash.' + this.rootDomain;
  },
  /**
   * Provides a valid lightning domain name by adding `lightning.` to the beginning of the baseUrl. So possible values are
   * `http://lightning.import.io`, 'http://lightning.staging-owl.com', 'http://lightning.dev-owl.com'
   * or a value of ENDPOINTS_LIGHTNING_BASE_URL environment variable.
   * @type {String}
   */
  get lightningBaseUrl() {
    return process.env.ENDPOINTS_LIGHTNING_BASE_URL || 'https://lightning.' + this.rootDomain;
  },
  /**
   * Provides a valid app domain name by adding `app.` to the beginning of the baseUrl. So possible values are
   * `http://app.import.io`, 'http://app.staging-owl.com', 'http://app.dev-owl.com'
   * or a value of ENDPOINTS_APP_BASE_URL environment variable.
   * @type {String}
   */
  get appBaseUrl() {
    return process.env.ENDPOINTS_APP_BASE_URL || 'https://app.' + this.rootDomain;
  },
  /**
   * Provides a valid prx domain name by adding `prx.` to the beginning of the baseUrl. So possible values are
   * `http://prx.import.io`, 'http://prx.staging-owl.com', 'http://prx.dev-owl.com'
   * or a value of ENDPOINTS_PRX_BASE_URL environment variable.
   * @type {String}
   */
  get prxBaseUrl() {
    return process.env.ENDPOINTS_PRX_BASE_URL || 'http://prx.' + this.rootDomain;
  },
  /**
   * Provides a valid prx domain name by adding `prx.` to the beginning of the baseUrl. So possible values are
   * `https://prx.import.io`, 'https://prx.staging-owl.com', 'https://prx.dev-owl.com'
   * or a value of ENDPOINTS_SECURE_PRX_BASE_URL environment variable.
   * @type {String}
   */
  get securePrxBaseUrl() {
    return process.env.ENDPOINTS_SECURE_PRX_BASE_URL || 'https://prx.' + this.rootDomain;
  },
  /**
   * Provides a valid css-prx domain name by adding `css-prx.` to the beginning of the baseUrl. So possible values are
   * `https://css-prx.import.io`, 'https://css-prx.staging-owl.com', 'https://css-prx.dev-owl.com'
   * or a value of ENDPOINTS_SECURE_PRX_BASE_URL environment variable.
   * @type {String}
   */
  get secureCssPrxBaseUrl() {
    return process.env.ENDPOINTS_SECURE_CSS_PRX_BASE_URL || 'https://css-prx.' + this.rootDomain;
  },
  /**
   * Provides a valid auth domain name by adding `auth.` to the beginning of the baseUrl. So possible values are
   * `https://auth.import.io`, 'https://auth.staging-owl.com', 'https://auth.dev-owl.com'
   * or a value of ENDPOINTS_AUTH_BASE_URL environment variable.
   * @type {String}
   */
  get authBaseUrl() {
    return process.env.ENDPOINTS_AUTH_BASE_URL || 'https://auth.' + this.rootDomain;
  },
  /**
   * Provides a valid rss domain name by adding `rss.` to the beginning of the baseUrl. So possible values are
   * `https://rss.import.io`, 'https://rss.staging-owl.com', 'https://rss.dev-owl.com'
   * or a value of ENDPOINTS_RSS_BASE_URL environment variable.
   * @type {String}
   */
  get rssBaseUrl() {
    return process.env.ENDPOINTS_RSS_BASE_URL || 'https://rss.' + this.rootDomain;
  },
  /**
   * Provides a valid chainsaw domain name by adding `autopilot.` to the beginning of the baseUrl. So possible values are
   * `https://autopilot.import.io`, 'https://autopilot.staging-owl.com', 'https://autopilot.dev-owl.com'
   * or a value of ENDPOINTS_AUTOPILOT_BASE_URL environment variable.
   * @type {String}
   */
  get autopilotBaseUrl() {
    return process.env.ENDPOINTS_AUTOPILOT_BASE_URL || 'http://autopilot.' + this.rootDomain;
  },
  /**
   * Provides a valid data domain name by adding `data.` to the beginning of the baseUrl. So possible values are
   * `https://data.import.io`, 'https://data.staging-owl.com', 'https://data.dev-owl.com'
   * or a value of ENDPOINTS_DATA_BASE_URL environment variable.
   * @type {String}
   */
  get dataBaseUrl() {
    return process.env.ENDPOINTS_DATA_BASE_URL || 'https://data.' + this.rootDomain;
  },
  /**
   * Provides a valid account domain name by adding `account.` to the beginning of the baseUrl. So possible values are
   * `https://account.import.io`, 'https://account.staging-owl.com', 'https://account.dev-owl.com'
   * or a value of ENDPOINTS_ACCOUNT_BASE_URL environment variable.
   * @type {String}
   */
  get accountBaseUrl() {
    return process.env.ENDPOINTS_ACCOUNT_BASE_URL || 'https://account.' + this.rootDomain;
  },
  /**
   * Provides a valid account domain name by adding `account.` to the beginning of the baseUrl. So possible values are
   * `https://suggest.import.io`, 'https://suggest.staging-owl.com', 'https://suggest.dev-owl.com'
   * or a value of ENDPOINTS_SUGGEST_BASE_URL environment variable.
   * @type {String}
   */
  get suggestBaseUrl() {
    return process.env.ENDPOINTS_SUGGEST_BASE_URL || 'https://suggest.' + this.rootDomain;
  },
  /**
   * Provides a valid account domain name by adding `emailverification.` to the beginning of the baseUrl. So possible values are
   * `https://emailverification.import.io`, 'https://emailverification.staging-owl.com', 'https://emailverification.dev-owl.com'
   * or a value of ENDPOINTS_EMAIL_VERIFICATION_BASE_URL environment variable.
   * @type {String}
   */
  get emailVerificationBaseUrl() {
    return process.env.ENDPOINTS_EMAIL_VERIFICATION_BASE_URL || 'https://emailverification.' + this.rootDomain;
  },
  /**
   * Provides a valid account domain name by adding `email-support.` to the beginning of the baseUrl. So possible values are
   * `https://email-support.import.io`, 'https://email-support.staging-owl.com', 'https://email-support.dev-owl.com'
   * or a value of ENDPOINTS_EMAIL_SUPPORT_BASE_URL environment variable.
   * @type {String}
   */
  get emailSupportBaseUrl() {
    return process.env.ENDPOINTS_EMAIL_SUPPORT_BASE_URL || 'https://email-support.' + this.rootDomain;
  },
  /**
   * Provides a valid data-suggest domain name by adding `data-suggest.` to the beginning of the baseUrl. So possible values are
   * `http://data-suggest.import.io`, 'http://data-suggest.staging-owl.com', 'http://data-suggest.dev-owl.com'
   * or a value of ENDPOINTS_DATA_SUGGEST_BASE_URL environment variable.
   * @type {String}
   */
  get dataSuggestBaseUrl() {
    return process.env.ENDPOINTS_DATA_SUGGEST_BASE_URL || 'https://data-suggest.' + this.rootDomain;
  },
  /**
   * Adds `maestro.` to the end of the apiBaseUrl. So possible values are
   * `https://api.import.io/maestro`, 'https://api.staging-owl.com/maestro', 'https://api.demo-owl.com/maestro' or a value of
   * ENDPOINTS_API_BASE_URL environment variable.
   * @type {String}
   */
  get maestroBaseUrl() {
    return process.env.ENDPOINTS_MAESTRO_BASE_URL || this.apiBaseUrl + '/maestro';
  },
  /**
   * Adds `get.` to the end of the apiBaseUrl. So possible values are
   * `https://get.import.io`, 'https://get.staging-owl.com', 'https://get.demo-owl.com' or a value of
   * ENDPOINTS_API_BASE_URL environment variable.
   * @type {String}
   */
  get unbounceSignupBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_SIGNUP_BASE_URL || 'https://get.' + this.rootDomain;
  },
  /**
   * Adds `try.` to the end of the apiBaseUrl. So possible values are
   * `https://try.import.io`, 'https://try.staging-owl.com', 'https://try.demo-owl.com' or a value of
   * ENDPOINTS_API_BASE_URL environment variable.
   * @type {String}
   */
  get unbounceSocialBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_SOCIAL_BASE_URL || 'https://try.' + this.rootDomain;
  },
  /**
   * Adds `contact.` to the end of the apiBaseUrl. So possible values are
   * `https://contact.import.io`, 'https://contact.staging-owl.com', 'https://contact.demo-owl.com' or a value of
   * ENDPOINTS_API_BASE_URL environment variable.
   * @type {String}
   */
  get unbounceContactBaseUrl() {
    return process.env.ENDPOINTS_UNBOUNCE_CONTACT_BASE_URL || 'https://contact.' + this.rootDomain;
  },
  /**
   * Provides a valid workflow domain name by adding `workflow.` to the beginning of the baseUrl. So possible values are
   * `https://workflow.import.io`, 'https://workflow.staging-owl.com', 'https://workflow.demo-owl.com'
   * or a value of ENDPOINTS_WORKFLOW_BASE_URL environment variable.
   * @type {String}
  */
  get workflowBaseUrl() {
    return process.env.ENDPOINTS_WORKFLOW_BASE_URL || 'https://workflow.' + this.rootDomain;
  },
  /**
   * Provides a valid user leads domain name by adding `userleads.` to the beginning of the baseUrl. So possible values are
   * `https://userleads.import.io`, 'https://userleads.staging-owl.com', 'https://userleads.demo-owl.com'
   * or a value of ENDPOINTS_USER_LEADS_BASE_URL environment variable.
   * @type {String}
   */
  get userLeadsBaseUrl() {
    return process.env.ENDPOINTS_USER_LEADS_BASE_URL || 'https://userleads.' + this.rootDomain;
  },
  /**
   * Provides a valid user britannica domain name by adding `britannica.` to the beginning of the baseUrl. So possible values are
   * `https://britannica.import.io`, 'https://britannica.staging-owl.com', 'https://britannica.demo-owl.com'
   * or a value of ENDPOINTS_BRITANNICA_BASE_URL environment variable.
   * @type {String}
   */
  get britannicaBaseUrl() {
    return process.env.ENDPOINTS_BRITANNICA_BASE_URL || 'https://britannica.' + this.rootDomain;
  },
  /**
   * Provides a valid user commerce domain name by adding `commerce.` to the beginning of the baseUrl. So possible values are
   * `https://commerce.import.io`, 'https://commerce.staging-owl.com', 'https://commerce.demo-owl.com'
   * or a value of ENDPOINTS_COMMERCE_BASE_URL environment variable.
   * @type {String}
   */
  get commerceBaseUrl() {
    return process.env.ENDPOINTS_COMMERCE_BASE_URL || 'https://commerce.' + this.rootDomain;
  }
};
exports.default = endpoints;